import { createElement, memo, useState, useEffect, useCallback } from '@max/max';
import SlideModal from '@max/leez-slide-modal';
import View from '@hfe/max-view';
import CitySelection from './CitySelection';
import { screenHeight } from '../util';
const isWeb = true;
function CitySelectionModal(p) {
    const [visible, setVisible] = useState(p.visible);
    const [city, setCity] = useState(p.city);
    const [cityType, setCityType] = useState(p.cityType);
    const receiveCity = useCallback((city, cityType) => {
        var _a;
        // p?._communication?.emit('cityChanged', {
        //   title: city?.name,
        //   value: city?.id?.toString()
        // })
        // console.log('cityChanged', {
        //   title: city?.name,
        //   value: city?.id?.toString()
        // })
        setCity(city === null || city === void 0 ? void 0 : city.name);
        setVisible(false);
        p === null || p === void 0 ? void 0 : p.onCityChange({
            title: city === null || city === void 0 ? void 0 : city.name,
            value: (_a = city === null || city === void 0 ? void 0 : city.id) === null || _a === void 0 ? void 0 : _a.toString()
        }, cityType);
    }, []);
    useEffect(() => {
        setVisible(p.visible);
        setCityType(p.cityType);
    }, [p.visible]);
    useEffect(() => {
        setCity(p.city);
    }, [p.city]);
    return <View>
      <SlideModal visible={visible} showHeader={false} showCloseBtn={false} maskClosable onClosePress={() => {
        setVisible(false);
        p === null || p === void 0 ? void 0 : p.onClose();
    }} addBottomSpace={false} 
    // modalMaxHeight={100}
    contentStyle={{
        margin: 0,
        paddingLeft: 0,
        paddingRight: 0,
        padding: 0
    }} modalProps={{
        maskStyle: {
            backgroundColor: 'rgba(0, 0, 0, 0.5)'
        }
    }} style={{
        borderTopLeftRadius: '30rpx',
        borderTopRightRadius: '30rpx',
        maxHeight: isWeb ? '80vh' : screenHeight * 0.7,
        height: undefined
    }}>
        <CitySelection emitCity={receiveCity} cityData={p.cityData} city={city} cityType={cityType} onClose={p === null || p === void 0 ? void 0 : p.onClose} locationCity={p === null || p === void 0 ? void 0 : p.city} _communication={p === null || p === void 0 ? void 0 : p._communication}/>
      </SlideModal>
    </View>;
}
export default memo(CitySelectionModal);
